/*Состояния*/
const state = () => ({
  content: "",
  type: "",
});
export { state };
